export const MIN_EPOCH_MS = Date.UTC(2000, 0, 1);
export const MAX_EPOCH_MS = Date.UTC(2100, 0, 1); // exclusive
export function assertEpochMs(ms) {
    if (!Number.isFinite(ms))
        throw new Error("Epoch must be a finite number");
    if (!Number.isSafeInteger(ms))
        throw new Error("Epoch must be a safe integer (ms)");
    if (ms < MIN_EPOCH_MS || ms >= MAX_EPOCH_MS)
        throw new Error("Epoch out of allowed range");
}
// Strict ISO-8601 UTC with Z.
// Allow: YYYY-MM-DDTHH:mm:ssZ or with fractional seconds of 1..3 digits.
// (Your old regex allowed only exactly .mmm; keep that if you want.)
const ISO_UTC_Z_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?Z$/;
/**
 * Convert date to unix timestamp ms
 * @param input user facing date time
 * @returns
 */
export function toEpochMs(input) {
    if (typeof input === "number") {
        assertEpochMs(input);
        return input;
    }
    if (input instanceof Date) {
        const ms = input.getTime();
        assertEpochMs(ms);
        return ms;
    }
    // string
    if (!ISO_UTC_Z_RE.test(input))
        throw new Error("Invalid ISO UTC string (must end with 'Z')");
    const ms = Date.parse(input);
    if (!Number.isFinite(ms))
        throw new Error("Invalid datetime string");
    assertEpochMs(ms);
    return ms;
}
/**
 * Convert to User facing Date Time
 * @param ms unix timestamp
 * @returns
 */
export function epochMsToIsoZ(ms) {
    assertEpochMs(ms);
    return new Date(ms).toISOString(); // always ends with Z
}
